import { useEffect, useState } from 'react';

import { useToastErrorHandler } from '@collab/libs/errors';

import { getApi } from 'libs/apim/apim.api';
import { AccessToken, AccessTokenWithTitle } from 'libs/volvoId/models';

import {
  getVolvoIdAccessToken,
  removeVolvoIdAccessToken,
} from './volvoIdAccessToken';

const useVolvoIdAccessToken = () => {
  const [token, setToken] = useState<AccessTokenWithTitle | null>(null);
  const [isLoading, setLoading] = useState(false);
  const handleWithToast = useToastErrorHandler();

  const tokenHandler = async (volvoIdToken: AccessToken) => {
    setLoading(true);
    try {
      const api = await getApi(volvoIdToken.apiName);

      const tokenWithTitle = {
        ...volvoIdToken,
        apiDisplayName: api.title,
      };

      setToken(tokenWithTitle);
    } catch (e) {
      handleWithToast(e, errorMessage);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const volvoIdToken = getVolvoIdAccessToken();
    if (volvoIdToken) {
      tokenHandler(volvoIdToken);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (token) {
      removeVolvoIdAccessToken();
    }
  }, [token]);

  const removeToken = () => {
    setToken(null);
    removeVolvoIdAccessToken();
  };

  return {
    token,
    isLoading,
    removeToken,
  };
};

const errorMessage = {
  key: 'volvo-id-token',
  text: 'Oops! Something went wrong when generating your Volvo ID Access Token',
};

export default useVolvoIdAccessToken;
